import { createReducer } from '@reduxjs/toolkit';
import { actions } from './actions';
const initialState = {
    isHeaderStickyMenuShown: false,
    isLocationMismatchBarOpen: false,
    isPageLevelNavigationStickyMenuShown: false,
    isCompareProductsStickyMenuShown: false,
    pageType: '',
    externalId: '',
    isMenuOpen: false,
    navProducts: {},
};
const formatNavProducts = (navProp) => navProp.reduce((acc, item) => {
    acc[item.externalId] = item.navProducts;
    return acc;
}, {});
function getUnitsRequestReducer(state) {
    return {
        ...state,
        ...{
            navProducts: {},
        },
    };
}
function getUnitsSuccessReducer(state, { payload }) {
    const formattedNavProducts = formatNavProducts(payload.data.segments);
    return {
        ...state,
        ...{
            navProducts: formattedNavProducts,
        },
    };
}
function getUnitsFailureReducer(state) {
    return {
        ...state,
        navProducts: {},
    };
}
function setPageTypeReducer(state, { payload }) {
    return {
        ...state,
        ...{
            pageType: payload,
        },
    };
}
function setIsMenuActiveReducer(state, { payload }) {
    return {
        ...state,
        isMenuOpen: payload,
    };
}
function setHeaderStickyMenuShownReducer(state, { payload }) {
    return {
        ...state,
        isHeaderStickyMenuShown: payload,
    };
}
function setHeaderSearchShownReducer(state, { payload }) {
    return {
        ...state,
        isHeaderSearchShown: payload,
    };
}
function setCompareProductsStickyMenuShown(state, { payload }) {
    return {
        ...state,
        isCompareProductsStickyMenuShown: payload,
    };
}
function setLocationMismatchBarOpen(state, { payload }) {
    return {
        ...state,
        isLocationMismatchBarOpen: payload,
    };
}
export const reducer = createReducer(initialState, (builder) => {
    builder
        .addCase(actions.request, getUnitsRequestReducer)
        .addCase(actions.success, getUnitsSuccessReducer)
        .addCase(actions.failure, getUnitsFailureReducer)
        .addCase(actions.setPageParam, setPageTypeReducer)
        .addCase(actions.setIsMenuActive, setIsMenuActiveReducer)
        .addCase(actions.setHeaderStickyMenuShown, setHeaderStickyMenuShownReducer)
        .addCase(actions.setHeaderSearchShown, setHeaderSearchShownReducer)
        .addCase(actions.setPageLevelNavigationStickyMenuShown, (state, action) => ({
        ...state,
        isPageLevelNavigationStickyMenuShown: action.payload,
    }))
        .addCase(actions.setCompareProductsStickyMenuShown, setCompareProductsStickyMenuShown)
        .addCase(actions.setLocationMismatchBarOpen, setLocationMismatchBarOpen);
});
